import { combineReducers } from 'redux';
import { influencerFeaturedReducer } from './influencers/reducers';
import { categoriesFeaturedReducer } from './categories/reducers';

export default combineReducers({
  influencers: influencerFeaturedReducer,
  categories: categoriesFeaturedReducer,
});
